import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Footer from "../shares/Footer";
import ContactusCard from "./ContactusCard";

// Others File
import locationIcon from "../../imgs/location.svg";
import callIcon from "../../imgs/call.svg";

const callText = ()=>{
return (
  <>
    <>021-84228</>
    <br />
    <>( هزار خط ) 999 الی 84229000-021</>
    <br />
    <>فکس : ۵-۸۸۵۵۲۰۸۴-۰۲۱</>
  </>
);
}
const damageText = () => {
  return (
    <>
      <>۱۴۰۱ (بدون کد)</>
      <br />
      <>۰۲۱-۴۱۵۵۸</>
      <br />
      <>۴۱۵۵۹ – ۰۲۱ (روابط عمومی)</>
    </>
  );
};

const Contactus = () => {
  return (
    <>
      <div className="hp-section-one">
        <Navbar activePage="contactus" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">تماس با ما</p>
        <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4">
          <div className="mt-8  grid md:grid-cols-3 gap-8 md:gap-16 mx-4">
            <ContactusCard
              icon={locationIcon}
              header="آدرس"
              text="تهران، ولی عصر ، ابتدای یوسف آباد ، خیابان سید جمال الدین اسد آبادی ، خیابان هفتم ، پلاک ۱۴ ، ساختمان ایرانیان پوشش"
            />
            <ContactusCard
              icon={callIcon}
              header="تلفن تماس"
              text={callText()}
            />
            <ContactusCard
              icon={callIcon}
              header="مرکز اعلام خسارت"
              text={damageText()}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Contactus;
